module.exports = __webpack_public_path__ + "wasserknapp2.ea2b1c43a9ba5f88dbbdeb8e1708dda7.png";